import React from 'react';
import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

const Copyright = (props) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Container
      component="main"
      maxWidth="false"
      sx={{
        mt: 10,
        bgcolor: '#000000',
        fontSize: '0.8rem',
        '@media (max-width: 479.95px)': { mt: 2, fontSize: '0.7rem' },
      }}
    >
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '@media (max-width: 479.95px)': { marginTop: 1 },
        }}
      >
        {/* #F59600 (245 150 0) */}
        <Grid container maxWidth="xl" sx={{ color: '#F59600', p: 5, '@media (max-width: 479.95px)': { p: 1.5 } }}>
          <Grid item xs={12} display="flex" justifyContent={{ xs: 'flex-start', sm: 'center' }} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            <Box sx={{ 
              display: { xs: 'flex', sm: 'block' },
              flexDirection: 'column',
              alignItems: { xs: 'flex-start', sm: 'center' },
              textAlign: 'left'
            }}>
              <Box component="span" sx={{ display: { xs: 'block', sm: 'inline' } }}>
                {"상호명: (주)워프코어 | 대표: 최 완 | 사업자등록번호: 623-81-02116"}
              </Box>
              <Box component="span" sx={{ display: { xs: 'block', sm: 'inline' }, mt: { xs: 0.5, sm: 0 } }}>
                {isDesktop ? " | " : ""}
                {"주소: 서울시 강서구 화곡로 416 가양 더 스카이밸리 지식산업센터 1117호"}
              </Box>
              <Box component="span" sx={{ display: { xs: 'block', sm: 'inline' }, mt: { xs: 0.5, sm: 0 } }}>
                {isDesktop ? " | " : ""}
                {"전화번호: 02-2131-4562"}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} display="flex" justifyContent={{ xs: 'flex-start', sm: 'center' }}>
            <Typography variant="h6" align="center" sx={{ 
              '@media (max-width: 479.95px)': { fontSize: '0.7rem', mt: 1, textAlign: 'left' }
            }} {...props}>
              {'Copyright © '}
              {new Date().getFullYear()}
              <Link color="inherit" href="http://www.warpcore.co.kr" style={{ textDecoration: 'none' }}>
                {" by WARPCORE Co.,LTD."}
              </Link>{' '}
              {'All Rights Reserved.'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Copyright;